import React, { useEffect, useState } from 'react'
import styles from './header.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from '../../utilities/auth/auth'
import ThemeToggle from '../../components/theme/theme'

const Header = ({ isOpenSet, isOpen }) => {
    const { user } = useAuth()

    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    console.log(user, isOpen, "header user=======");
    const outline = localStorage?.theme === 'dark' ? '' : '';
    return (
        <>
            {!isSmallScreen && <div className={`${styles.header} ${!isOpen ? styles.open : ''}`} >
                <button
                    onClick={() => isOpenSet(prev => !prev)}
                    style={
                        {
                            height: isSmallScreen ? '70px' : '100px',
                            border: 'none',
                            background: 'none',
                        }
                    }>
                    {/* <FontAwesomeIcon icon={faBars} className={styles.bar} /> */}
                    <img src='/UraCab.png' alt="uc" className={styles.logo} style={{ margin: '0' }} />
                </button>
                {isOpen && <h1 style={{ margin: '0', overflow: 'hidden' }}>
                    UraCab
                </h1>}


            </div>}

            {isSmallScreen && <div className={styles.smheader}>
                <button
                    onClick={() => isOpenSet(prev => !prev)}
                    style={
                        {
                            height: isSmallScreen ? '70px' : '100px',
                            border: 'none',
                            background: 'none',
                        }
                    }>
                    <FontAwesomeIcon icon={faBars} className={styles.bar} />
                </button>
                <img src='/UraCab.png'
                    alt="uc"
                    className={styles.smalllogo}
                    style={{
                        margin: '0',
                        // background: `${background}`,
                        filter: 'drop-shadow(0.5px 0 0 #fff) drop-shadow(-0.5px 0 0 #fff) drop-shadow(0 0.5px 0 #fff) drop-shadow(0 -0.5px 0 #fff)'
                    }} />
            </div>}
        </>
    )
}

export default Header